/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function LiveEditsOn({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#LiveEditsOn_svg__a)"><path d="M.4 8a.6.6 0 0 0 1.2 0A6.4 6.4 0 0 1 8 1.6.6.6 0 0 0 8 .4 7.6 7.6 0 0 0 .4 8" /><path d="M3.4 8a.6.6 0 0 0 1.2 0A3.4 3.4 0 0 1 8 4.6a.6.6 0 0 0 0-1.2A4.6 4.6 0 0 0 3.4 8" /><path fillRule="evenodd" d="M10.768 3.99a2.6 2.6 0 0 1 3.677 0l.354.353a2.6 2.6 0 0 1 0 3.677l-6.403 6.403a2.6 2.6 0 0 1-1.343.714l-3.348.65a.6.6 0 0 1-.703-.704l.65-3.347a2.6 2.6 0 0 1 .713-1.343zm2.829.848a1.4 1.4 0 0 0-1.98 0l-5.94 5.94 2.333 2.334 5.94-5.94a1.4 1.4 0 0 0 0-1.98zm-6.513 9.044-2.177-2.177q-.051.125-.078.26l-.48 2.474 2.475-.48q.134-.026.26-.077" clipRule="evenodd" /></g><defs><clipPath id="LiveEditsOn_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;